import * as styles from './Pagination.css';
import { PaginationButton } from './PaginationButton';
import { IPaginationItem } from '../../types/layouts/layoutsCatalog';
import { CheckboxButtonGroup } from '@cian/ui-kit';
import { ChangeEvent, useCallback, useMemo } from 'react';

interface IPaginationProps {
  prevButton?: IPaginationItem;
  nextButton?: IPaginationItem;
  onClick(page: number): void;
  pages: IPaginationItem[];
}

export function Pagination({ onClick, pages, prevButton, nextButton }: IPaginationProps) {
  const activePage = useMemo(() => [pages.find(page => page.disabled)?.value as number], [pages]);

  const onChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, v: number[]) => {
      const value = v.pop();
      if (!value || activePage[0] === value) {
        return;
      }

      onClick(value);
    },
    [onClick, activePage],
  );

  return (
    <nav className={styles['pagination']} data-testid="Pagination">
      {prevButton && <PaginationButton {...prevButton} onClick={onClick} />}
      <CheckboxButtonGroup options={pages} onChange={onChange} value={activePage} spliced size="M" />
      {nextButton && <PaginationButton {...nextButton} onClick={onClick} />}
    </nav>
  );
}
